export var TriggerFlow;
(function (TriggerFlow) {
    /** Provider is triggered during cart interactions. */
    TriggerFlow["CART"] = "CART";
    /** Provider is triggered during the checkout process. */
    TriggerFlow["CHECKOUT"] = "CHECKOUT";
})(TriggerFlow || (TriggerFlow = {}));
export var LogoSize;
(function (LogoSize) {
    LogoSize["UNKNOWN_LOGO_SIZE"] = "UNKNOWN_LOGO_SIZE";
    LogoSize["SMALL"] = "SMALL";
    LogoSize["MEDIUM"] = "MEDIUM";
    LogoSize["LARGE"] = "LARGE";
})(LogoSize || (LogoSize = {}));
export var Alignment;
(function (Alignment) {
    Alignment["UNKNOWN_ALIGNMENT"] = "UNKNOWN_ALIGNMENT";
    Alignment["SIDE"] = "SIDE";
    Alignment["CENTER"] = "CENTER";
})(Alignment || (Alignment = {}));
export var DestinationScope;
(function (DestinationScope) {
    /** No additional destinations are requested */
    DestinationScope["SPECIFIC_DESTINATIONS"] = "SPECIFIC_DESTINATIONS";
    /** All Destinations */
    DestinationScope["WORLDWIDE"] = "WORLDWIDE";
})(DestinationScope || (DestinationScope = {}));
export var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    RequestedFields["ADDITIONAL_FEES_SERVICE_PLUGIN"] = "ADDITIONAL_FEES_SERVICE_PLUGIN";
    RequestedFields["VALIDATIONS_SERVICE_PLUGIN"] = "VALIDATIONS_SERVICE_PLUGIN";
    RequestedFields["TAX"] = "TAX";
    RequestedFields["DISCOUNT_RULES"] = "DISCOUNT_RULES";
    RequestedFields["CHECKOUT"] = "CHECKOUT";
    RequestedFields["DELIVERY"] = "DELIVERY";
    RequestedFields["PREMIUM_SITE"] = "PREMIUM_SITE";
    RequestedFields["BUSINESS_INFO"] = "BUSINESS_INFO";
})(RequestedFields || (RequestedFields = {}));
/** Determines the reset cycle of the feature usage. */
export var FeaturePeriod;
(function (FeaturePeriod) {
    FeaturePeriod["NO_PERIOD"] = "NO_PERIOD";
    FeaturePeriod["MILLISECOND"] = "MILLISECOND";
    FeaturePeriod["SECOND"] = "SECOND";
    FeaturePeriod["MINUTE"] = "MINUTE";
    FeaturePeriod["HOUR"] = "HOUR";
    FeaturePeriod["DAY"] = "DAY";
    FeaturePeriod["WEEK"] = "WEEK";
    FeaturePeriod["MONTH"] = "MONTH";
    FeaturePeriod["YEAR"] = "YEAR";
})(FeaturePeriod || (FeaturePeriod = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map